<template>
    <div>
      Empty  
    </div>
</template>


<script>
export default {
  name: 'EmptyView',
  props: {
      msg: String,            
  },
}
</script>